import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromApplicationDataStore from './state/application-data-store.reducer';

/* effects */
import { ApplicationDataStoreEffects } from './state/application-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* ApplicationDataStore State */
    StoreModule.forFeature(
      fromApplicationDataStore.featureKey,
      fromApplicationDataStore.reducer,
      { initialState: fromApplicationDataStore.initialState },
    ),
    EffectsModule.forFeature([ApplicationDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class ApplicationDataStoreModule {}
